module.exports = __webpack_public_path__ + "img/stack01.a6e99c57.svg";